export const SHEET_OPEN_EVENT = 'ft1.order-core.reductionBlockSheetOpen';

export interface SheetOpenEventDetail {
    id: string;
}

export const emitSheetOpen = (detail: SheetOpenEventDetail): void => {
    document.dispatchEvent(new CustomEvent<SheetOpenEventDetail>(SHEET_OPEN_EVENT, { detail }));
};

export const onSheetOpen = <T extends SheetOpenEventDetail>(handler: (detail: T) => void): void => {
    document.addEventListener(SHEET_OPEN_EVENT, event => {
        handler((event as CustomEvent<T>).detail);
    });
};
